import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class SiteTemplate extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/site/template'
    super(store, path)
  }
}
